import { useEffect, useState } from 'react';
import { getServices } from '@general/api/onSchedAPI';

const useOnSchedService = onSchedAPIToken => {
    const [onSchedService, setOnSchedService] = useState(null);

    useEffect(() => {
        if (!onSchedAPIToken) {
            return;
        }

        (async () => {
            const {
                data: { data: services },
            } = await getServices({ apiToken: onSchedAPIToken });

            if (services.length > 0) {
                setOnSchedService(services[0]);
            }
        })();
    }, [onSchedAPIToken]);

    return onSchedService;
};

export default useOnSchedService;
